import Filters from '../../components/filters/script.js';

const propelInit = function() {
const blocks = document.querySelectorAll('.block-archive-filter-top');

blocks.forEach((block) => {
	const postsWrapper = block.querySelector('.filters__post-wrapper');

	if (postsWrapper) {
		new Filters(block, postsWrapper);
	}
});

};
propelInit();
window.propel = window.propel || {};
window.propel.blocks = window.propel.blocks || {};
window.propel.blocks['archive-filter-top'] = window.propel.blocks['archive-filter-top'] || {};
window.propel.blocks['archive-filter-top'].script = propelInit;
